import { render, staticRenderFns } from "./cleanandafforest.vue?vue&type=template&id=81ddc4fa&"
import script from "./cleanandafforest.vue?vue&type=script&lang=js&"
export * from "./cleanandafforest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports